import { createConfirmation } from "react-confirm";
import AddInvestmentDialog from "./AddInvestmentDialog";

export const showAddInvestmentDialog = createConfirmation(AddInvestmentDialog);
